import {
  ISimpleSubcontractor,
  ISubcontractorMember,
} from "subcontractors/models";
import { ISelectOption } from "shared/models";
import { isEmpty } from "lodash";
import { http } from "shared/api/http";

const apiPath = `${process.env.REACT_APP_API_BASE_URL}/api/v1/subcontractors`;

export const getSimpleSubcontractorsByType = async (type: string) => {
  const res = await http.get<ISimpleSubcontractor[]>(
    `${apiPath}?type=${type}`
  );
  return res?.data;
};

export const getSimpleSubcontractors = async () => {
  const res = await http.get<ISimpleSubcontractor[]>(`${apiPath}`);
  return res?.data;
};

export const getSubcontractorMembers = async (id: string) => {
  const res = await http.get<ISubcontractorMember[]>(
    `${apiPath}/${id}/members`
  );
  return res?.data;
};

export const getSubcontractorMemberSelectOptions = async (id?: string) => {
  let url = `${apiPath}/options`;

  if (!isEmpty(id)) {
    url += `?id=${id}`;
  }

  const res = await http.get<ISelectOption[]>(url);
  return res?.data;
};

export const createSubcontractor = async (
  subcontractor: ISimpleSubcontractor
) => {
  const res = await http.post<ISimpleSubcontractor>(
    `${apiPath}`,
    subcontractor
  );
  return res?.data;
};

export const updateSubcontractor = async (
  subcontractor: ISimpleSubcontractor
) => {
  const res = await http.put<ISimpleSubcontractor>(
    `${apiPath}/${subcontractor.id}`,
    subcontractor
  );
  return res?.data;
};

export const deleteSubcontractor = async (id: string) => {
  await http.delete(`${apiPath}/${id}`);
};
